import React from 'react';
import { Link } from 'react-router-dom';

/** لوگوی تایپوگرافی نوبار — فقط navbar، نه hero */
export default function NavbarWordmark({ className = '' }) {
  return (
    <Link
      to="/"
      className={`navbar-wordmark group inline-flex shrink-0 items-center transition-[opacity,transform] duration-200 hover:opacity-90 active:scale-[0.98] ${className}`}
      aria-label="فلاشر"
    >
      <span className="navbar-wordmark__text" aria-hidden>
        فلاشر
      </span>
    </Link>
  );
}
